(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atwill-b2-colors"] && !Shopify.designMode) return;
  try {
    if (!window.atwillColorGallery) {
  window.atwillColorGallery = true;
  const syncColor = (root, variant) => {
    const source = root.querySelector('[data-b2-variants]');
    if (!source) return;
    const data = JSON.parse(source.textContent);
    const index = data.options.findIndex(name => ['color', 'colour'].includes(name.toLowerCase()));
    const selected = root.querySelector('.b2-color-picker input:checked');
    const color = variant?.options?.[index] || selected?.value;
    root.querySelectorAll('.b2-color-picker input').forEach(input => {
      if (input.value === 'Navy' && input.nextElementSibling?.matches('label')) {
        input.nextElementSibling.textContent = 'Blue';
      }
    });
    const displayColor = color === 'Navy' ? 'Blue' : color;
    const legendValue = root.querySelector('.b2-color-picker .input-fieldset__legend span');
    if (legendValue && displayColor) legendValue.textContent = displayColor;
    if (!color) return;
    const normalize = value => String(value || '').trim().toLowerCase().replace(/^navy$/, 'blue');
    const images = Array.from(root.querySelectorAll('[data-b2-image-color]'));
    const hasMatch = images.some(image => normalize(image.dataset.b2ImageColor) === normalize(color));
    if (hasMatch) images.forEach(image => {
      image.hidden = normalize(image.dataset.b2ImageColor) !== normalize(color);
    });
    root.querySelectorAll('[data-b2-color-name]').forEach(label => { label.textContent = displayColor; });
  };
  const init = (scope) => scope.querySelectorAll('[data-b2-color-gallery]').forEach(root => syncColor(root));
  document.addEventListener('product:variant-change', event => {
    const root = event.target.closest('[data-b2-color-gallery]');
    if (root) syncColor(root, event.detail?.variant);
  });
  document.addEventListener('change', event => {
    const root = event.target.closest('[data-b2-color-gallery]');
    if (root && event.target.matches('.b2-color-picker input')) syncColor(root);
  });
  document.addEventListener('shopify:section:load', () => init(document));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atwill-b2-detail"] && !Shopify.designMode) return;
  try {
    if (!window.atwillB2VariantListener) {
  window.atwillB2VariantListener = true;
  document.addEventListener('product:variant-change', (event) => {
    const root = event.target.closest('.atwill-b2');
    if (!root) return;
    const source = root.querySelector('[data-b2-variants]');
    if (!source) return;
    const data = JSON.parse(source.textContent);
    const variant = data.variants.find(v => String(v.id) === String(event.detail?.variant?.id));
    const price = root.querySelector('[data-b2-price]');
    const size = root.querySelector('[data-b2-size]');
    if (variant) {
      if (price) price.textContent = variant.price;
      const index = data.options.findIndex(name => ['size', 'sizing'].includes(name.toLowerCase()));
      if (size) size.textContent = index < 0 ? '' : variant.options[index];
    } else if (size) { size.textContent = ''; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atwill-b2-zoom"] && !Shopify.designMode) return;
  try {
    if (!window.atwillB2Zoom) {
  window.atwillB2Zoom = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-b2-zoom]');
    if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const dialog = link.closest('.atwill-b2')?.querySelector('.b2-zoom-dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      const image = document.createElement('img');
      image.src = link.href;
      image.alt = link.querySelector('img')?.alt || '';
      dialog.querySelector('.b2-zoom-content').replaceChildren(image);
      dialog.querySelector('.b2-zoom-caption').textContent = image.alt;
      dialog.showModal();
    } else if (event.target.matches('.b2-zoom-dialog, .b2-zoom-content')) {
      event.target.closest('dialog').close();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atwill-mobile-nav"] && !Shopify.designMode) return;
  try {
    function positionAtwillMobileNav(scope=document){
 if(!window.matchMedia('(max-width:719px)').matches)return;
 scope.querySelectorAll('.atwill-mobile-nav').forEach(nav=>{
  const active=nav.querySelector('[aria-current]');
  if(!active)return;
  const item=active.getBoundingClientRect(),box=nav.getBoundingClientRect();
  if(item.right>box.right||item.left<box.left)nav.scrollLeft+=item.left-box.left-12;
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>positionAtwillMobileNav());else positionAtwillMobileNav();
document.addEventListener('shopify:section:load',event=>positionAtwillMobileNav(event.target));
  } catch(e) { console.error(e); }
})();

})();
